import React from 'react';
import ContentDisplay from './components/ContentDisplay';
import { ContentProvider } from '../../contexts/ContentContext';

/**
 * 콘텐츠 페이지 컴포넌트
 * 콘텐츠 목록을 표시하는 페이지입니다.
 */
const ContentsPage = () => {
  return (
    <ContentProvider>
      <ContentDisplay section="content" />
    </ContentProvider>
  );
};

export default ContentsPage;